<ion-item lines="none" [class]="'form-group-' + layout()">
  @if (labelKey()) {
    <ion-label class="form-label">
      {{ labelKey() | translate }}
      @if (isRequired()) {
        <span class="required-indicator" aria-label="required">*</span>
      }
    </ion-label>
  }
  <div class="form-field-wrapper">
    <ion-select
      class="mbp-select"
      [class.select-error]="errorMessage()"
      [value]="internalValue()"
      [placeholder]="placeholderKey() | translate"
      [disabled]="disabled()"
      label-placement="stacked"
      interface="popover"
      (ionChange)="handleChange($event)"
      (ionBlur)="markAsTouched()">
      @for (viewOption of viewOptions(); track viewOption.value) {
        <ion-select-option [value]="viewOption.value">{{ viewOption.label }}</ion-select-option>
      }
    </ion-select>
    <mbp-form-error [message]="errorMessage()"></mbp-form-error>
  </div>
</ion-item>
